module.exports = __webpack_public_path__ + "img/abella-logo.f290ffb9.svg";